"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Drawer = void 0;
const react_1 = __importStar(require("react"));
const Icon_1 = __importDefault(require("../Icon/Icon"));
const Theme_1 = require("../../Theme/Theme");
const Drawer_styles_1 = require("./Drawer.styles");
const headerSeparator = (variant) => {
    switch (variant) {
        case 'border':
            return `border-bottom: 1px solid ${Theme_1.theme.colors.gray[50]}`;
        case 'shadow':
            return `box-shadow: 0 2px 2px ${Theme_1.theme.colors.gray[50]}`;
        case 'none':
            return '';
        default:
            return `border-bottom: 1px solid ${Theme_1.theme.colors.gray[50]}`;
    }
};
const DrawerHeader = ({ children, open, height, headerSeparatorType, onClose, }) => {
    return (react_1.default.createElement(Drawer_styles_1.DrawerHeaderContainer, { open: open, height: height, headerSeparatorType: headerSeparatorType, onClose: onClose },
        children,
        react_1.default.createElement("div", { style: { position: 'absolute', top: '16px', right: '24px' } },
            react_1.default.createElement(Icon_1.default, { icon: "close", size: "25", "aria-label": "Close", onClick: onClose ? onClose : undefined }))));
};
const Drawer = (_a) => {
    var { open, width, overlay, overlayVisible = true, drawerHeaderContent, headerHeight, headerSeparatorType = 'border', children, onClose, overlayZIndex, drawerZIndex } = _a, props = __rest(_a, ["open", "width", "overlay", "overlayVisible", "drawerHeaderContent", "headerHeight", "headerSeparatorType", "children", "onClose", "overlayZIndex", "drawerZIndex"]);
    const drawerRef = (0, react_1.useRef)(null);
    const [isClosing, setIsClosing] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (event) => {
            if (open &&
                drawerRef.current &&
                !drawerRef.current.contains(event.target)) {
                onClose === null || onClose === void 0 ? void 0 : onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [open, onClose]);
    (0, react_1.useEffect)(() => {
        if (!open && isClosing) {
            setTimeout(() => {
                setIsClosing(false);
            }, 250);
        }
        else if (open && !isClosing) {
            setIsClosing(true);
        }
    }, [open, isClosing]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        overlay && (react_1.default.createElement(Drawer_styles_1.Overlay, { open: open, overlayVisible: overlayVisible, onClose: onClose ? onClose : undefined, isClosing: isClosing, overlayZIndex: overlayZIndex })),
        react_1.default.createElement(Drawer_styles_1.DrawerSlide, Object.assign({ open: open, width: width, onClose: onClose, ref: drawerRef, isClosing: isClosing, drawerZIndex: drawerZIndex }, props),
            react_1.default.createElement(DrawerHeader, { open: open, height: headerHeight, onClose: onClose, headerSeparatorType: headerSeparator(headerSeparatorType) }, drawerHeaderContent),
            react_1.default.createElement(Drawer_styles_1.DrawerContentContainer, null, children))));
};
exports.Drawer = Drawer;
//# sourceMappingURL=Drawer.js.map